import Button from 'components/button'
import textServices from 'services/text-services'
import useMainClass from 'hooks/use-main-cass'
import { ContainerCheckpointQr, DescriptionCheckpointQr, ImgCheckpointQr, TitleCheckpointQr } from '../styles/styled.components'

function CheckpointOnBoarding({ handleClick }: { handleClick: () => void }) {
  useMainClass('checkpoint__pop-up')

  return (
    <ContainerCheckpointQr className="flex-1 w-full flex flex-col gap-6 py-7">
      {textServices?.findByText('checkpoint/onboarding/html', <div className="w-full flex flex-col gap-6 px-7 flex-1">
        <div className="flex-1 w-full flex flex-col items-center justify-center gap-6 text-center">
          <TitleCheckpointQr>{textServices?.findByText('checkpoint/onboarding/title', { es: <>CONTESTA<br />Y GANA</>, en: <>ANSWER<br />AND WIN</> })}</TitleCheckpointQr>
          <DescriptionCheckpointQr className="flex flex-col items-center justify-center gap-5">{textServices?.findByText('checkpoint/onboarding/description', { es: <><b>¿Ya tienes tu ID?</b>Si no lo tienes córrele a registrarte para poder participar</>, en: <><b>Do you already have your ID?</b> If you don&apos;t have it, please register to participate.</> })}</DescriptionCheckpointQr>
        </div>
        <ImgCheckpointQr src={`${AZURE_BASE_URL}/access-qr-card-id.${textServices.findByText('checkpoint/onboarding/typeImage', 'webp')}`} alt="card id" />
      </div>)}
      <div className="w-full px-7">
        <Button onClick={handleClick}>{textServices?.findByText('checkpoint/onboarding/button', { es: 'COMENCEMOS', en: 'START' })}</Button>
      </div>
    </ContainerCheckpointQr>
  )
}

export default CheckpointOnBoarding